import React from 'react'

export default store => [
  {
    title: '套包类型',
    dataIndex: 'title',
    width: 100
  },
  {
    title: '购买时间',
    width: 100,
    dataIndex: 'created_at',
    render: created_at => {
      return <span>{created_at.split(' ')[0]}</span>
    }
  },
  {
    title: '状态',
    dataIndex: 'is_start_use',
    width: 200,
    render: (o, { status }) => {
      // 1 未生效
      // 2 生效中
      // 3 已失效
      switch (Number(status)) {
        case 1:
          return <span style={{ color: '#333333', fontSize: 14 }}>生效中</span>
        case 2:
          return <span style={{ color: '#2fc286', fontSize: 14 }}>未生效</span>
        case 3:
          return <span style={{ color: '#ff801a', fontSize: 14 }}>已失效</span>
        default:
          return <span style={{ color: '#ff801a', fontSize: 14 }}>已失效</span>
      }
    }
  },
  {
    title: '生效时间',
    dataIndex: 'start_at',
    width: 100,
    render: (o, { start_at, end_at, is_start_use }) => {
      return Number(is_start_use) === 0 ||
        !start_at ||
        start_at == '0000-00-00' ? (
        <span>-</span>
      ) : (
        <span>
          {start_at}~{end_at}
        </span>
      )
    }
  },
  {
    title: '操作',
    dataIndex: 'operation',
    width: 90,
    render: (o, record) => {
      const { id, title, status, use_days, product_id } = record
      // let isShowActive = true
      // if (!!start_at) {
      //   const startYear = start_at.split('-')[0]
      //   const startMonth = start_at.split('-')[1]
      //   const startDay = start_at.split('-')[2]
      //   const now = new Date().toLocaleDateString().replace(/\//g, '-')
      //   const nowYear = now.split('-')[0]
      //   const nowMonth = now.split('-')[1]
      //   const nowDay = now.split('-')[2]
      //   if (
      //     nowYear == startYear &&
      //     +startMonth == +nowMonth &&
      //     +startDay == +nowDay + 1
      //   ) {
      //     isShowActive = false
      //   }
      // }
      return (
        <div>
          {status == 2 ? (
            <a
              onClick={store.activate({ id, use_days, title, product_id })}
              style={{ marginRight: 20 }}
            >
              马上激活
            </a>
          ) : (
            '-'
          )}
        </div>
      )
    }
  }
]
